import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { UiPersistentNotificationComponent } from './ui-persistent-notification';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule,
    ],
    declarations: [
        UiPersistentNotificationComponent,
    ],
    exports: [
        UiPersistentNotificationComponent,
    ],
})
export class UiPersistentNotificationModule {
}
